/* Mobile-only top bar with hamburger menu to open sidebar in a sheet. */

import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Sheet, SheetContent, SheetTrigger } from "@/components/ui/sheet";
import { Menu } from "lucide-react";
import { AppSidebar } from "@/components/layout/AppSidebar";
import { KiwiIcon } from "@/components/brand/KiwiIcon";
import { KiwiSkinRenderer } from "@/components/brand/KiwiSkinRenderer";
import { Skeleton } from "@/components/ui/skeleton";
import { useActiveKiwiSkin } from "@/hooks/useActiveKiwiSkin";
import { AddSourceDialog } from "@/components/sources/AddSourceDialog";

export function MobileHeader() {
  const [open, setOpen] = useState(false);
  const { activeSkin, isLoading: isSkinLoading } = useActiveKiwiSkin();

  return (
    <div className="flex items-center gap-2 px-4 py-3 border-b border-border lg:hidden">
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetTrigger asChild>
          <Button variant="ghost" size="icon">
            <Menu className="size-5" />
          </Button>
        </SheetTrigger>
        <SheetContent side="left" className="p-0 w-64" showCloseButton={false}>
          <div className="h-full" onClick={() => setOpen(false)}>
            <AppSidebar onClose={() => setOpen(false)} />
          </div>
        </SheetContent>
      </Sheet>
      {isSkinLoading ? (
        <Skeleton className="size-5 rounded-full" />
      ) : activeSkin ? (
        <KiwiSkinRenderer config={activeSkin} className="size-5" />
      ) : (
        <KiwiIcon className="size-5 text-primary" />
      )}
      <span className="text-lg font-bold">FeedKiwi</span>
      <div className="ml-auto">
        <AddSourceDialog />
      </div>
    </div>
  );
}
